"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NavItem = _ref => {
  let {
    title,
    link
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactRouter.NavLink, {
    to: link
  }, title));
};
NavItem.defaultProps = {
  link: "#"
};
NavItem.propTypes = {
  link: _propTypes.default.string,
  isActive: _propTypes.default.func
};
var _default = exports.default = NavItem;